import React, {useEffect, useState} from 'react';
import Button from "@material-ui/core/Button";
import {StyledBadge, textColors, useClasses} from "./styles";
import {NavLink} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Field, Form, Formik} from "formik";
import DateRangePickerComponent from "../common/DateRangePickerComponent/DateRangePickerComponent";
import {MuiThemeProvider} from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Modal from "../common/Modals/Modal";
import Skeleton from "@material-ui/lab/Skeleton";
import Pagination from "@material-ui/lab/Pagination";
import {getNavReviewParams, getReviewList, setNavReviewParams, setReviewListFromCache} from "./actions";
import Preloader from "../common/Preloader/Preloader";
import {usePrevious} from "../common/CustomHook/usePrevious";

const RenderFilters = ({
                           objects = {}, ratingList = {
        1: "1 звезда",
        2: "2 звезды",
        3: "3 звезды",
        4: "4 звезды",
        5: "5 звезд"
    }, filter = {}, setFilter, setPage
                       }) => {
    let [filterCount, updateFilterCount] = useState(0);
    let [show, toggleModalShow] = useState(false);

    const objectKeys = Object.keys(objects)

    const filterClearValues = {
        datesReviews: [null, null],
        rating: [],
        object: objectKeys
    };

    const calcFilterCount = values => {
        let result = 0;
        for (let oKey in values) {
            if (oKey == 'object' || oKey == 'datesReviews') continue;
            if (Array.isArray(values[oKey])) {
                if (values[oKey].join('')) {
                    result++;
                }
            } else if (values[oKey]) {
                result++;
            }
        }
        return result;
    }

    const toggleShow = () => {
        toggleModalShow(!show)
    };

    const onSubmit = values => {
        updateFilterCount(calcFilterCount(values));
        toggleModalShow(false);
        setPage(1)
        setFilter(values)
    }

    return objectKeys.length ? (
        <div className="filters mb-2">
            <Formik initialValues={filter}
                    onSubmit={onSubmit}
                    enableReinitialize>
                {({handleSubmit, setFieldValue, setValues, values}) => {

                    const handleChangeObjectFilter = ({target}) => {
                        let curValue = target.value;
                        if (curValue.length < 1) {
                            setFieldValue(target.name, [Object.keys(objects)[0]]);
                            return;
                        }
                        setFieldValue(target.name, curValue);
                    }

                    const handleClearFilterFields = () => {
                        setValues(filterClearValues);
                        setFilter(filterClearValues);
                        updateFilterCount(0);
                    }

                    return (
                        <Form onSubmit={handleSubmit}>
                            <div className="row g-2 align-items-center">
                                <div className="col-lg-4 h-100">
                                    <DateRangePickerComponent
                                        name="datesReviews"
                                        startText="Дата отзыва, от"
                                        endText="Дата отзыва, до"
                                    />
                                </div>
                                <div className="col-lg-2 h-100">
                                    <MuiThemeProvider theme={textColors}>
                                        <Field name="object">
                                            {({field, form}) => (
                                                <FormControl variant="outlined" size="small"
                                                             className="w-100 mb-1 long-multiple-select">
                                                    <InputLabel htmlFor={`${field.name}_id`}>Гостевой
                                                        объект</InputLabel>
                                                    <Select
                                                        {...field}
                                                        onChange={handleChangeObjectFilter}
                                                        id={`${field.name}_id`}
                                                        multiple
                                                        displayEmpty
                                                        label="Гостевой объект"
                                                        renderValue={selected => selected.map((key) => objects[key].name).join(', ')}
                                                    >
                                                        {
                                                            Object.keys(objects).map((key) => {
                                                                let objectItem = objects[key];
                                                                return (
                                                                    <MenuItem key={key} value={key}>
                                                                        <Checkbox
                                                                            checked={field.value.indexOf(key) > -1}/>
                                                                        <ListItemText primary={objectItem.name}/>
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </MuiThemeProvider>
                                </div>
                                <div className="col-lg-6 h-100">
                                    <div className="filters-btns">
                                        <Button type="submit" className="btn filters-btn">
                                            <FontAwesomeIcon icon={"search"} className="me-1"/> поиск
                                        </Button>
                                        <Button onClick={toggleShow} className="btn filters-btn">
                                            <StyledBadge
                                                badgeContent={filterCount}>
                                                <FontAwesomeIcon icon={"filter"} className="me-1"/>

                                                фильтры
                                            </StyledBadge>

                                        </Button>
                                        <Button className="btn filters-btn" onClick={handleClearFilterFields}>
                                            очистить
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show} title={"Фильтры"}
                                   textBtnOk={"Применить"}>
                                <div className="row g-2">
                                    <div className="col-12">
                                        <MuiThemeProvider theme={textColors}>
                                            <Field name="rating">
                                                {({field, form}) => (
                                                    <FormControl variant="outlined" size={"small"}
                                                                 className={"w-100"}>
                                                        <InputLabel htmlFor={`${field.name}_id`}>Оценка</InputLabel>
                                                        <Select
                                                            {...field}
                                                            id={`${field.name}_id`}
                                                            multiple
                                                            label="Оценка"
                                                            renderValue={selected => selected.map((key) => ratingList[key]).join(', ')}
                                                        >

                                                            {
                                                                Object.keys(ratingList).map((key) => (
                                                                    <MenuItem key={key} value={key}>
                                                                        <Checkbox
                                                                            checked={field.value.indexOf(key) > -1}/>
                                                                        <ListItemText primary={ratingList[key]}/>
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                            {/*<MenuItem value={'1'}>
                                                                <Checkbox
                                                                    checked={field.value.indexOf(key) > -1}/>
                                                                <ListItemText primary={statusList[key]}/>
                                                            </MenuItem>*/}


                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </MuiThemeProvider>
                                    </div>
                                </div>
                            </Modal>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    ) : <Skeleton animation='wave' width='100%' height={35} variant='rect'/>;
}

const RenderReviewsRow = ({dateCreate, dateRest, name, rating, plus, minus}) => {

    let stars = [];
    for (let i = 0; i < rating; i++) {
        stars.push(<FontAwesomeIcon key={i} icon={"star"}/>)
    }

    return (
        <tr className="c-table__row">
            <td className=" c-table__cell">
                <span className="cell__title-mobile">Дата отзыва</span>
                {dateCreate}
            </td>
            <td className=" c-table__cell">
                <span className="cell__title-mobile">Дата отдыха</span>
                {dateRest}
            </td>
            <td className=" c-table__cell">
                <span className="cell__title-mobile">Гость</span>
                {name}
            </td>
            {/* <td className=" c-table__cell">
                <span className="cell__title-mobile">Объект</span>
                {object}
                <Button className={`w-100`} component={NavLink} to="/lk">Просмотр</Button>
            </td>*/}
            <td className="c-table__cell">
                <span className="cell__title-mobile">Оценка</span>
                <div className="stars">
                    {stars}
                </div>

            </td>
            <td className="c-table__cell">
                <span className="cell__title-mobile">Плюсы</span>
                {plus || "нет"}
            </td>
            <td className="c-table__cell">
                <span className="cell__title-mobile">Минусы</span>
                {minus || "нет"}

            </td>
        </tr>

    )
}

const RenderReviewsTable = ({reviews}) => {

    let skeletonCell = []
    for (let i = 0; i < 48; i++) {
        skeletonCell.push(<Skeleton animation='wave' key={i} height={35} variant='rect'/>)
    }

    if (!reviews) {
        return (
            <>
                <div style={{display: 'flex'}}>
                    <Skeleton style={{marginBottom: 5, flex: '1 1 auto'}} animation='wave' height={35}
                              variant='rect'/>
                </div>
                <div style={{display: 'grid', gridTemplateColumns: "repeat(6, 1fr)", gridGap: "5px"}}>
                    {skeletonCell}
                </div>
            </>
        )
    }
    return (<table className="c-table">
            <thead className="c-table__row c-table__header">
            <tr>
                <th className="c-table__cell">
                    Дата отзыва
                </th>
                <th className="c-table__cell">
                    Дата отдыха
                </th>
                <th className=" c-table__cell">
                    Гость
                </th>
                {/*<th className=" c-table__cell">
                    Объект
                </th>*/}
                <th className=" c-table__cell">
                    Оценка
                </th>
                <th className=" c-table__cell">
                    Плюсы
                </th>
                <th className=" c-table__cell">
                    Минусы
                </th>
            </tr>

            </thead>
            <tbody>

            {reviews.map((review, i) => <RenderReviewsRow key={i} {...review}/>)}
            </tbody>
        </table>

    )
}

const formatDate = (date) => {
    return `${date.toLocaleDateString('ru-RU')}`
}

const formatFilter = (filters) => {
    if (filters.datesReviews[0]) {
        filters.dateCreateFrom = formatDate(new Date(filters.datesReviews[0]));
    }
    if (filters.datesReviews[1]) {
        filters.dateCreateTo = formatDate(new Date(filters.datesReviews[1]));
    }
}


const Reviews = (props) => {
    // Кеш страниц с бронированиями, в том числе с применённым фильтром
    const [cachePagesWithNavParams, setCachePagesWithNavParams] = useState({});
    const [page, setPage] = useState(1);
    const {
        objectId, objects, reviews, navParams, getReviewList, getNavReviewParams,
        setReviewListFromCache, setReviewNavParamsFromCache, searchObjects, userRole
    } = props;


    // Состояние фильра
    let [filter, setFilter] = useState({
        datesReviews: [null, null],
        rating: [],
        object: []
    });

    useEffect(() => {
        if (!objects && objectId && userRole === "MODERATOR") {
            searchObjects(objectId)
        }
    }, [objects])


    //общее количество выбранных фильтров
    const filtersCondition = [...filter.datesReviews, ...filter.rating].filter(item => item).length


    // Т.к. в начальном фильтре не указаны объекты, нужно установить состояние фильтра и добавить туда ID объектов, если они уже пришли в props
    if (filter.object.length < 1 && objects && objects.length !== 0) {
        setFilter({...filter, object: objectId ? [objectId] : Object.keys(objects)});
    }

    const prevFilters = usePrevious(JSON.stringify(filter));

    useEffect(() => {
        if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
            if (objects) {
                let filterForRequest = JSON.parse(JSON.stringify(filter));
                formatFilter(filterForRequest);
                delete filterForRequest["datesReviews"]

                getReviewList({
                    filter: JSON.stringify(filterForRequest),
                    page: page
                })

                if (prevFilters !== JSON.stringify(filter)) {
                    getNavReviewParams({
                        filter: JSON.stringify(filterForRequest)
                    })
                }
            }

        } else {
            setReviewListFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['items']);
            setReviewNavParamsFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['navParams']);
        }
    }, [getReviewList, filter, page])


    // После изменения страницы, сохраняем текущую в кеш (если её ещё там нет), со всеми установленными фильтрами
    const handleChange = (event, value) => {
        setReviewListFromCache(null);
        if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
            let newPage = {};
            newPage[JSON.stringify(filter) + '_' + page] = {};
            newPage[JSON.stringify(filter) + '_' + page]['items'] = reviews;
            newPage[JSON.stringify(filter) + '_' + page]['navParams'] = navParams;
            setCachePagesWithNavParams({...cachePagesWithNavParams, ...newPage});
        }
        setPage(value);

    };


    const classes = useClasses();

    if (!objects || !reviews) {
        return <Preloader loading={true} text={"Ищем ваши отзывы"}/>
    }
    return (
        <div className="main">
            <div className="container-fluid">
                {objects && objects.length !== 0 && <RenderFilters objects={objects}
                                                                   objectId={objectId}
                                                                   filter={filter}
                                                                   setPage={setPage}
                                                                   setFilter={setFilter}/>}
                {navParams && navParams['pages'] > 1 &&
                <Pagination className={`${classes.pagination} mb-2 ms-auto`} count={navParams['pages']} page={page}
                            onChange={handleChange}/>}


                <RenderReviewsTable reviews={reviews}/>


                {reviews && reviews.length === 0 && <h6 className="w-100 text-center mt-5">
                    {filtersCondition === 0
                        ? "На выбранном объекте пока нет бронирований"
                        : "Нет бронирований, по выбранным фильтрам"
                    }
                </h6>}
            </div>
        </div>

    )
}


export default Reviews;